import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmCustomerDetailsRoute: InvariantJiraRoute = {
	name: 'csm-customer-details',
	path: '/jira/customer-service-management/customers/:customerId',
	exact: true,
};
